<template>
  <div class="popup_index_warp">
    <van-popup round  v-model="value" closeable position="bottom" :style="{ height: '70%' }" close-icon="close" @close="closePopup">
      <div class="address_index-warp">
        <div class="title">
          <strong>{{leftTitle}}</strong>
          <div class="address_info_item">
             <img class="img" src="@/assets/image/icon_add@3x.png" alt />
             <div class="address_info_info">
               <p class="p1">{{addressDetails.addressUpdateBefore.name}} {{addressDetails.addressUpdateBefore.phone}}</p>
               <p class="p2">{{addressDetails.addressUpdateBefore.address}}</p>
             </div>
          </div>
          <div class="address_info_price">合计运费：￥{{addressDetails.addressUpdateBefore.freight}}</div>
        </div> 
        <div class="title">
          <strong>{{rightTitle}}</strong>
          <div class="address_info_item">
             <img class="img" src="@/assets/image/icon_add@3x.png" alt />
             <div class="address_info_info">
               <p class="p1">{{addressDetails.addressUpdateAfter.name}} {{addressDetails.addressUpdateAfter.phone}}</p>
               <p class="p2">{{addressDetails.addressUpdateAfter.address}}</p>
             </div>
          </div>
          <div class="address_info_price">合计运费：￥{{addressDetails.addressUpdateAfter.freight}}</div>
        </div>
        <div class="dese" v-show="type=='user'">备注：地址仅可修改一次，请仔细确认，如涉及运费差异变动，请联系蜜蜂处理即可</div>
        <div class="adderss_index-btn">
          <van-button block color="#F8D541" round @click="$emit('update:value',false)" v-show="type=='bees'">我知道了</van-button>
          <van-button class="bt bd"  round @click="$emit('update:value',false)" v-show="type=='user'">再想想</van-button>
          <van-button class="bt be" color="#F8D541" round @click="submitUp" v-show="type=='user'">确认无误</van-button>
        </div>
      </div>
    </van-popup>
  </div>  
</template>
<script>
export default {
  data(){
    return{
      addressDetails:{
        addressUpdateBefore:{},
        addressUpdateAfter:{}
      },
      showD:true
    }
  },
  props:{
    subOrderId:{
      default:0,
    },
    leftTitle:{default:'发货前地址',type:String},
    rightTitle:{default:'发货后地址',type:String},
    addressId:{
      default:0,
    },
    value:{
      default:false
    },
    type:{
      default:'bees',
      type:String
    }
  },
  methods:{
    closePopup(){
       this.$emit('update:value',false);
    },
    getaddressDetails(){
      let parmes={
        subOrderId:this.subOrderId || this.$route.query.subId,
      }
      if(this.addressId){
        parmes.addressId =this.addressId;
      }
      this.http({
        url:'/order/appOrder/addressModifyRecord',
        method:'post',
        parmes:parmes
      }).then(rps=>{
        if(rps.code==200){
          this.addressDetails = rps.data;
        }
      })
    },
    submitUp(){
      this.$emit('closeModal',true)
      this.$emit('update:value',false)
    }
  },
  created(){
    this.getaddressDetails();
  }
}
</script>
<style lang="less" scoped>
  .popup_index_warp{
    .address_index-warp{
      text-align: left;
      padding: 30px;
      strong{
        font-size: 32px;
        color: #333;
      }
      .address_info_item{
        display: flex;
        justify-content: flex-start;
        padding: 30px;
        margin-top: 20px; 
        align-items: center;
        background-color: #f7f7f7;
        border-radius: 10px;
        .img{
          width: 80px;
          height: 80px;
          object-fit: cover;
          margin-right: 20px;
        }
        .address_info_info{
          text-align: left;
          .p1{
            color: #333;
            font-size: 26px;
          }
          .p2{
            font-size: 24px;
            color: #999;
          }
        }
      }
      .address_info_price{
        text-align: right;
        padding-top: 14px;
        font-size: 26px;
        color: #999;
        padding-bottom: 20px;
      }
      .adderss_index-btn{
        padding-top: 15px;
        display: flex;
        justify-content: space-around;
        align-items: center;
        .bt{
          width: 300px;
          color: #333;
        }
        .bt.bd {
          color: #999;
          border-color: #999;
        }
        .bt.be {
          color: #333 !important;
        }
      }
      .dese{
        color: #F8A651;
        font-size: 26px;
      }
    }
  }
</style>